/**
 * @author 3173
 * @description 我的作业列表
 * @Date 2020/9/28
 */
import React from 'react';
import { connect } from 'dva';
import { templateConfig, reduxTemplateCofig } from './config'

import { framework_tool,utils_tool ,component_tool} from '../../../tool'
let { WizContainer, WizReduxTemplate } = framework_tool;
let { checkStrLength } = utils_tool;
let {  WizBrowserExport } = component_tool;

class HomeworkList extends WizContainer {

  componentName = 'homeworkList';

  constructor(props) {
    super(props);
    const {history} = props
    let pathname = '/homework/homeworkList'
    if (history.location && history.location.pathname && history.location.pathname.startsWith('/perm/homeworkListPerm')) {
      pathname = '/perm/homeworkListPerm'
    }
    this.state = {
    }
    this.pathname = pathname
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleListData(nextProps, nextState, key) {
    let o = nextProps[key]
    let len = 15
    if (o['success']) {
      let f = (v) => {
        // v && v.forEach(val => {
        //   val['name'] = checkStrLength(val['name'], len);
        // });
      }
      // f(o['data']['records'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '标题',
        field: 'name',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '分类',
        field: 'categoryName',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '形式',
        field: 'typesName',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '状态',
        field: 'stateStr',
        width: 10,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '作业受众',
        field: 'scope',
        width: 30,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left', wrapText: true  },
        },
      },
      {
        headerName: '是否需要批阅',
        field: 'reviewTypeStr',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '是否公开展示',
        field: 'openStr',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '开始时间',
        field: 'startDate',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '结束时间',
        field: 'endDate',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '评分人',
        field: 'reviewersName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '满分',
        field: 'totalScore',
        width: 10,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '及格分',
        field: 'passScore',
        width: 10,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      }

    ]
    if (o['success']) {
      let data = o['data']
      let _data = []
      data && data.forEach(d => {
        let _d = { ...d }
      let authData = d['authInfo']
      let target = ''
        if (authData && Object.keys(authData)) {
          if (authData['orgIds'] && authData['orgIds'].length) {
            target += ' 组织范围：'
            authData['orgIds'].forEach(org => {
              target += org['name'] + ','
            });
            target += '\n'
          }
          if (authData['positionIds'] && authData['positionIds'].length) {
            target += ' 岗位：'
            authData['positionIds'].forEach(org => {
              target += org['name'] + ','
            });
            target += '\n'
          }
          if (authData['positionCategoryIds'] && authData['positionCategoryIds'].length) {
            target += ' 岗位分类：'
            authData['positionCategoryIds'].forEach(org => {
              target += org['name'] + ','
            });
            target += '\n'
          }
          if (authData['personIds'] && authData['personIds'].length) {
            target += ' 指定人员：'
            authData['personIds'].forEach(org => {
              target += org['userName'] +'('+org['fullName'] +'),'
            });
            target += '\n'
          }
        }
        _d['scope'] = target
        _data.push(_d)
      });

      WizBrowserExport({
        title: '作业信息',
        sheetName: '作业信息',
        columns: columnDefs.filter((_, index) => index),
        rows: _data,
        filename: '作业信息.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }

  }

  _render() {
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig: templateConfig({pathname: this.pathname}),
      apiDataFormat: {
        add: this._handleCMD,
        list: this._handleListData,
        updateState: this._handleCMD,
        export: this._handleFile,
        delete: this._handleCMD
      },

    })
    return <WizReduxTemplate {..._reduxTemplateCofig}  />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(HomeworkList);
